import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../../styles/Form.css";
import { FIELDS, MODE, TOAST_MESSAGES } from "../../../constants/SiteConstants";
import ServiceForm from "./ServiceForm";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  {
    label: FIELDS.TITLE,
    name: "title",
    placeholder: "Enter Title",
    required: true,
  },
  {
    label: FIELDS.ICON,
    name: "icon",
    placeholder: "Select icon",
    required: true,
  },
];

const AddService = () => {
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    try {
      await axios.post(`${API_URL}/services/createService`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      toast.success(TOAST_MESSAGES.DATA_SAVED);
      navigate("/services");
    } catch (error) {
      toast.error(TOAST_MESSAGES.ERROR_ADD);
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add Service
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/services")}
        >
          &times;
        </button>
      </div>
      <ServiceForm
        mode={MODE.ADD}
        onSubmit={handleSubmit}
        fields={fields}
        selectedType="dropdown"
        onAddMulti={true}
        passOptionsinString={true}
      />
    </div>
  );
};

export default AddService;
